const ACTION_ICON_SX = { minWidth: 34 };

const ACTION_ITEM_SX = {
  height: 42,
  minHeight: 42,
  py: 0,
  px: 1.25,
  alignItems: 'center',
  '& .MuiListItemText-root': { my: 0 }
};

const ACTION_TEXT_PROPS = { noWrap: true };

const GROUP_HEADER_SX = {
  px: 1.5,
  pt: 1,
  pb: 0.25,
  color: 'text.secondary',
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0.4,
  lineHeight: '18px',
  textTransform: 'uppercase'
};

export { ACTION_ICON_SX, ACTION_ITEM_SX, ACTION_TEXT_PROPS, GROUP_HEADER_SX };
